/* eslint-disable react/static-property-placement */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import update from 'immutability-helper'

import ParamBuilder from './search-param-builder'

// Antons note: HOCs are named with lower case and kebab-case for folders, just like redux's connect etc.
// This is to avoid confusion with react components, since they are just functions
// check out https://reactjs.org/docs/higher-order-components.html

function searchableTable(WrappedComponent) {
  return class extends Component {
    static propTypes = {
      onLoadSearchData: PropTypes.func,
    }

    static defaultProps = { onLoadSearchData: () => {} }

    constructor(props) {
      super(props)
      this.state = { searchInfo: new ParamBuilder() }
    }

    onSearch(searchTerm, searchRole) {
      let searchInfo

      this.setState(
        state => {
          searchInfo = update(state.searchInfo, {
            search: { $set: searchTerm },
            role: { $set: searchRole },
          })
          return update(state, {
            searchInfo: { $set: searchInfo },
          })
        },
        () => this.props.onLoadSearchData(searchInfo),
      )
    }

    render() {
      return (
        <WrappedComponent
          onSearch={(searchTerm, searchRole) =>
            this.onSearch(searchTerm, searchRole)
          }
          {...this.props}
        />
      )
    }
  }
}

export default searchableTable
